import React from "react";
import styles from "./InfluencerInfo.module.scss";
import { parseCurrency } from "../../../helpers/StringManipulation";
import DashboardFooter from "./DashboardFooter";

export default function InfluencerInfo({
  influencerReport,
  accountType,
  hasSales
}) {
  return (
    <>
      {influencerReport && influencerReport.length > 0 && (
        <>
          <h3 className={styles.heading}>Best Influencers</h3>
          <div className={styles.desc}>
            As you know, greeting new subscribers is like meeting someone for
            the first time. You want to make a good impression, but you don’t
            know exactly what to say, and you end up spending a lot of time
            trying to craft the perfect introduction.
          </div>

          <ul className={styles.articlesList}>
            {influencerReport.map((event) => (
              <InfluencerCard
                image={event.influencer.picture}
                views={event.totalVideoViews}
                revenue={event.totalRevenue}
              />
            ))}
          </ul>
        </>
      )}

      <ul className={styles.linkList}>
        <DashboardFooter accountType={accountType} hasSales={hasSales} />
      </ul>
    </>
  );
}

function InfluencerCard({ image, viewCount, revenue }) {
  return (
    <li className={styles.item}>
      <div className={styles.thumbnail}>
        <img src={image} alt="" />
      </div>
      <div className={styles.contentHolder}>
        <h4 className={styles.title}>Views {viewCount || 0}</h4>
        <div className={styles.income}>${parseCurrency(revenue || 0)}</div>
      </div>
    </li>
  );
}
